module.exports = __webpack_public_path__ + "img/boboze_bobocoin.gm.5ea1c79.png";